export const ShippingSpeedMessages = {
  'en-US': {
    shippingSpeed: {
      Standard: 'Standard (Ground)',
      Expedited: 'Expedited (2-4 days)',
      Overnight: 'Overnight (1 day)',
      UPSGround: 'UPS Ground',
      USPSFirstClass: 'USPS First Class',
      Priority: 'Priority',
      FedexGround: 'FedEx Ground',
      Fedex2Day: 'FedEx 2 Day',
      FedexOvernight: 'FedEx Overnight',
      UPS2Day: 'UPS 2 Day',
      UPSOvernight: 'UPS Overnight',
      UPSSurePost: 'UPS Surepost',
      USPSExpress: 'USPS Express',
      UPSMailInnovation: 'UPS Mail Innovation',
      DHLExpressInternationalExpedited: 'DHL Express International Expedited',
      USPSMediaMail: 'USPS Media Mail',
      Shipbob2Day: 'ShipBob 2-Day Express',
      NextDay: 'Next Day',
      SameDay: 'Same Day',
      EbayGuaranteedDelivery: '2 Day Partner Beta',
      Shipbob2DayUPSGround: 'ShipBob 2 Day UPS Ground',
      Shipbob2DayUPS2Day: 'ShipBob 2 Day UPS 2 Day',
      StandardDDP: 'Standard DDP',
      ExpeditedDDP: 'Expedited DDP',
      Dropshipping: 'Dropshipping',
      FlavorCloudDDPStandard: 'FlavorCloud DDP Standard',
      FlavorCloudDDPExpedited: 'FlavorCloud DDP Expedited',
      Standard5Day: 'Standard 5-Day',
      Economy5Day: 'Economy 5-Day',
      Standard3Day: 'Standard 3-Day',
      Economy3Day: 'Economy 3-Day',
      InternalUseOnlyStandardOrderUpgrade: 'Internal UseOnly Standard Order Upgrade',
      GlobalEDDPExpedited: 'Global E DDP Expedited',
      CanadaSection321Standard: 'Canada Section 321 Standard',
      CanadaSection321Expedited: 'Canada Section 321 Expedited',
      LargeLetter: 'Large Letter',
      USPSGroundAdvantage: 'USPS Ground Advantage',
      DeMinimis: 'DeMinimis',
      AmazonSWA: 'Amazon SWA'
    }
  }
}

export const ShipOptionsMessages = {
  'en-US': {
    shipOptions: {
      ShipbobOptimized: 'Shipbob Optimized',
      CarrierSpecific: 'Carrier Specific',
      ShipbobCustom: 'ShipBob Custom'
    }
  }
}

export const CarrierSpecificMessages = {
  'en-US': {
    carrierSpecific: {
      USPS: 'USPS',
      UPS: 'UPS',
      FedEx: 'Fed Ex',
      DHL: 'DHL',
      UPSMailInnovation: 'UPS Mail Innovation'
    }
  }
}
